import React from "react";
import { Instagram, Youtube, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#C5A059]/15 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full border border-[#C5A059]/60 flex items-center justify-center text-[#C5A059] font-display text-xl">
                C
              </span>
              <div className="flex flex-col leading-tight">
                <span className="overline text-[10px]">Christopher</span>
                <span className="font-display text-[#F5F5F0] text-xl tracking-wide">
                  DePamphilis
                </span>
              </div>
            </div>
            <p className="mt-6 text-[#A1A1AA] max-w-sm leading-relaxed">
              An evening of magic, mystery, and meticulous craft —
              performed for those who insist on memorable.
            </p>
          </div>

          <div className="md:col-span-3">
            <span className="overline">Explore</span>
            <ul className="mt-4 space-y-3">
              {["about", "media", "reviews", "booking"].map((id) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    data-testid={`footer-link-${id}`}
                    className="font-display text-[#F5F5F0] text-lg hover:text-[#C5A059] transition-colors capitalize"
                  >
                    {id}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <span className="overline">Elsewhere</span>
            <div className="mt-4 flex items-center gap-3">
              {[
                { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/chrisiscuriousmagic/?hl=en" },
                { Icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@MagicianChrisD" },
                { Icon: Mail, label: "Email", href: "mailto:chriscuriouscreations@gmail.com" },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  aria-label={label}
                  className="w-10 h-10 rounded-full border border-[#C5A059]/25 hover:border-[#C5A059] hover:bg-[#C5A059] hover:text-black text-[#C5A059] flex items-center justify-center transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <p className="mt-6 text-[#A1A1AA] text-xs leading-relaxed">
              For press, casting, and partnership inquiries,
              <br />
              please use the booking form above.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#C5A059]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#A1A1AA]">
          <span>© {year} Christopher DePamphilis · All illusions reserved.</span>
          <span className="font-italic-display text-[#C5A059] text-base">
            A little wonder goes a long way.
          </span>
        </div>
      </div>
    </footer>
  );
}
